import React, {SyntheticEvent, useState, useLayoutEffect, useRef} from "react";
import intl from "react-intl-universal";
import classNames from "classnames";


import {ContextMenuInterface} from "../../../ContextMenuInterface";


import {DeleteIcon} from "../../../../../components/icons/DeleteIcon";
import {CloseIcon} from "../../../../../components/icons/CloseIcon";
import {CheckIcon} from "../../../../../components/icons/CheckIcon";
import {LinkIcon} from "../../../../../components/icons/editor/LinkIcon";
import {EditIcon} from "../../../../../components/icons/editor/EditIcon";
import {Tooltip} from "../../../../../components/Tooltip"


import './InContextEditBar.css';


export interface InContextEditBarProps extends ContextMenuInterface {
    isEditingAtOpen?: boolean;
    onSave: (newValue: string) => void;
    onDelete: () => void;
    defaultValue: string;
}

export const InContextEditBar = ({
                                     handleClose,
                                     isEditingAtOpen = false,
                                     onSave,
                                     isDark,
                                     onDelete,
                                     defaultValue,
                                 }: InContextEditBarProps) => {
    const [isEditing, setIsEditing] = useState(isEditingAtOpen);
    const [value, setValue] = useState(defaultValue);
    const inputRef = useRef<HTMLInputElement>(null);

    const _onSave = (event: SyntheticEvent) => {
        event.preventDefault();
        onSave(value);
        setIsEditing(false);
    }

    useLayoutEffect(() => {
        if (inputRef.current && isEditing) {
            inputRef.current.focus();
            inputRef.current.select();
            inputRef.current.scrollLeft = 0;
        }
    }, [inputRef, isEditing]);

    return (
        <form
            className={classNames({
                'InContextEditBar': true,
                'theme-dark': isDark,
            })}
            onSubmit={_onSave}>
            <LinkIcon size={16}/>
            <div className={'InContextEditBar_content'}>
                {
                    isEditing
                        ? (
                            <input className="InContextEditBar_input body-large"
                                   value={value}
                                   onChange={e => setValue(e.target.value)}
                                   ref={inputRef}
                                   placeholder={intl.get('InContextEditBar.edit-placeholder').d('Paste or type a link...')}
                            />
                        )
                        : (
                            <a className="InContextEditBar_href" href={value} target="_blank"
                               rel="noopener noreferrer">{value}</a>
                        )
                }
            </div>
            <div className='InContextEditBar_buttons'>
                {
                    isEditing
                        ? (
                            <>
                                <Tooltip title={intl.get('tooltip.inContextEditBar.saveLink').d('Save Link')}>
                                    <CheckIcon className={classNames({
                                        'InContextEditBar_button': true,
                                        'visibility_hidden': value.length === 0,
                                    })} size={16} onClick={_onSave}
                                               additionalPadding={8}
                                    />
                                </Tooltip>
                                <Tooltip title={intl.get('tooltip.inContextEditBar.close').d("Close")}>
                                    <CloseIcon className='InContextEditBar_button' size={16} onClick={handleClose}
                                               additionalPadding={8}
                                    />
                                </Tooltip>
                            </>
                        )
                        : (
                            <>
                                <Tooltip title={intl.get('tooltip.inContextEditBar.editLink').d("Edit Link")}>
                                    <EditIcon className='InContextEditBar_button'
                                              size={16}
                                              additionalPadding={8}
                                              onClick={(event) => {
                                                  event.stopPropagation();
                                                  return setIsEditing(true);
                                              }}
                                    />
                                </Tooltip>
                                <Tooltip title={intl.get('tooltip.inContextEditBar.deleteLink').d("Delete Link")}>
                                    <DeleteIcon className='InContextEditBar_button'
                                                size={16}
                                                additionalPadding={8}
                                                onClick={onDelete}
                                    />
                                </Tooltip>
                            </>
                        )
                }
            </div>
        </form>
    )
}
